import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Sidebar from "../../sidebar/Sidebar";
import Navbar from "../../navbar/Navbar";
import config from "../../../config";
const API_ENDPOINT = `${config.baseURL}${config.apiEndpoint}/getUsers/ALL`;
const API_ENDPOINT1 = `${config.baseURL}${config.apiEndpoint}/getAllGymService`;
const API_ENDPOINT2 = `${config.baseURL}${config.apiEndpoint}/cms/billing`;
const theme = createTheme();
const AddBilling = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  let navigate = useNavigate();

  const [pack, setPack] = useState("");
  const [user, setUser] = useState("");
  const [gymService, setGymService] = useState("");
  const [activeFrom, setActiveFrom] = useState("");
  const [activeTo, setActiveTo] = useState("");
  const [totalFee, setTotalFee] = useState("");
  const [paidFee, setPaidFee] = useState("");
  const [feeDue, setFeeDue] = useState("");
  const [remarks, setRemarks] = useState("");
  const [allUsers, setAllUsers] = useState("");
  const [allServices, setAllServices] = useState("");

  const getUsers = async () => {
    let res = await axios.get(
      API_ENDPOINT
    );

    console.log("responce=============->", res.data.users);

    const modifiedData = res.data.users.reduce(
      (prev, current) => [
        ...prev,
        {
          ...current,
          userName: current.firstName + (current.lastName ?? ""),
          email: current.email,
          clientNumber: current.number,
          id: current._id,
        },
      ],
      []
    );
    setAllUsers(modifiedData);
  };

  const getGymService = async () => {
    let res = await axios.get(
      API_ENDPOINT1
    );

    console.log("responce=============->", res.data.data);

    const modifiedData = res.data.data.reduce(
      (prev, current) => [
        ...prev,
        {
          ...current,
          id: current._id,
        },
      ],
      []
    );
    setAllServices(modifiedData);
  };

  useEffect(() => {
    getUsers();
    getGymService();
  }, []);

  const onSubmit = async (data, e) => {
    e.preventDefault();
    console.log("pack =>", pack);
    console.log("user =>", user);
    console.log("activeFrom =>", activeFrom);
    console.log("activeTo =>", activeTo);
    console.log("totalFee =>", totalFee);
    console.log("gymService =>", gymService);
    var data = new FormData();
    data.append("package", pack);
    data.append("user", user);
    data.append("activeFrom", activeFrom);
    data.append("activeTo", activeTo);
    data.append("totalFee", totalFee);
    data.append("paidFee", paidFee);
    data.append("feeDue", feeDue);
    data.append("remarks", remarks);
    data.append("gymService", gymService);
    let config = {
      method: "post",
      url: API_ENDPOINT2,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        window.alert("success");
        navigate("/cms/billing");
      })
      .catch(function (error) {
        console.log(error);
        window.alert("fail");
      });
  };
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Box
                sx={{
                  marginTop: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar sx={{ m: 1, backgroundColor: "#fd9206" }}>
                  <AddCircleOutlineIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                  Add Cms Billing Record
                </Typography>
                <Box sx={{ mt: 3 }}>
                  <div className="AddEnquiryContent">
                    <Grid item xs={12} sm={6}>
                      <TextField
                        autoComplete="pack"
                        {...register("pack", { required: false })}
                        name="package"
                        fullWidth
                        id="pack"
                        label="Package"
                        autoFocus
                        required
                        value={pack}
                        onChange={(e) => setPack(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="activeFrom">ActiveFrom</label>
                      <TextField
                        autoComplete="activeFrom"
                        type="date"
                        name="activeFrom"
                        fullWidth
                        id="activeFrom"
                        label=""
                        value={activeFrom}
                        onChange={(e) => setActiveFrom(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="activeTo">ActiveTo</label>
                      <TextField
                        fullWidth
                        id="activeTo"
                        type="date"
                        label=""
                        required
                        value={activeTo}
                        onChange={(e) => setActiveTo(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <select
                        {...register("users", { required: true })}
                        id="user"
                        className="form-select"
                        value={user}
                        onChange={(e) => {
                          setUser(e.target.value);
                        }}
                      >
                        <option value={""} disabled>
                          Choose User
                        </option>

                        {allUsers.length &&
                          allUsers?.map((x, key) => {
                            return (
                              <option key={key} value={x.id}>
                                {x.userName}
                              </option>
                            );
                          })}
                      </select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <select
                        {...register("service", { required: true })}
                        id="gymService"
                        className="form-select"
                        value={gymService}
                        onChange={(e) => {
                          setGymService(e.target.value);
                        }}
                      >
                        <option value={""} disabled>
                          Choose Service
                        </option>

                        {allServices.length &&
                          allServices?.map((x, key) => {
                            return (
                              <option key={key} value={x.id}>
                                {x.title}
                              </option>
                            );
                          })}
                      </select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        id="totalFee"
                        label="totalFee"
                        required
                        value={totalFee}
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          maxLength: 6,
                          minLength: 0,
                        }}
                        onChange={(e) => setTotalFee(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        id="paidFee"
                        label="paidFee"
                        required
                        value={paidFee}
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          maxLength: 6,
                          minLength: 0,
                        }}
                        onChange={(e) => setPaidFee(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        id="feeDue"
                        label="feeDue"
                        required
                        value={feeDue}
                        inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                          maxLength: 6,
                          minLength: 0,
                        }}
                        onChange={(e) => setFeeDue(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        id="remarks"
                        label="remarks"
                        required
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </Grid>
                    <button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                    >
                      Add Billing
                    </button>
                    <Grid container justifyContent="flex-end">
                      <Grid item>
                        <Link href="/cms/billing" variant="body2">
                          Back to all Billing Records
                        </Link>
                      </Grid>
                    </Grid>
                  </div>
                </Box>
              </Box>
            </Container>
          </ThemeProvider>
        </form>
      </div>
    </div>
  );
};

export default AddBilling;
